import { Select, SelectButton, SelectList } from '@saas-ui/react';
import React, { startTransition, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState_TRANSITION_SUPPORT_UNSTABLE, useRecoilValue } from 'recoil';

import { factoriesQuery } from '~/atoms/factoriesQuery';
import { factoryPicker } from '~/atoms/factoryPicker';
import { partnerPicker } from '~/atoms/partnerPicker';

const FactoryPicker = () => {
  const { t } = useTranslation(['translation']);
  const partner = useRecoilValue(partnerPicker);
  const factoriesList = useRecoilValue(factoriesQuery);
  const [factoryPickerState, setFactoriesPickerState] =
    useRecoilState_TRANSITION_SUPPORT_UNSTABLE(factoryPicker);

  useEffect(() => {
    startTransition(() => {
      setFactoriesPickerState(undefined);
    });
  }, [partner]);

  return factoriesList && factoriesList.length > 1 ? (
    <Select
      name="factory-picker"
      value={factoryPickerState ?? 'all'}
      onChange={(value) => {
        if (value === 'all') {
          startTransition(() => {
            setFactoriesPickerState(undefined);
          });
          return;
        }
        startTransition(() => {
          setFactoriesPickerState(value as string);
        });
      }}
      options={[
        {
          value: 'all',
          label: t('all'),
        },
        ...factoriesList.map((factory) => ({
          value: factory.factory_name,
          label: factory.factory_name,
        })),
      ]}
    >
      <SelectButton />
      <SelectList zIndex="dropdown" />
    </Select>
  ) : null;
};

export default () => (
  <React.Suspense>
    <FactoryPicker />
  </React.Suspense>
);
